import { BoxProps, Chip, MenuItem, Select, Stack, TextField } from "@mui/material"
import React from "react"
import { useTranslation } from "react-i18next"
import CancelIcon from "@mui/icons-material/Cancel"
import { Box, Typography } from "src/UILibrary"
import { SelectDataType } from "./SelectDataType"
import { getLabel } from "src/modules/helper"

type Props = {
  sx?: BoxProps
  name?: string
  required?: boolean
  selected: (string | number)[]
  handleSelected: any
  datas: SelectDataType[]
  inputStyle?: any
  labelStyle?: any
  disabled?: boolean
  hasText?: boolean
  text?: string
  handleText?: any
  multiline?: boolean
  validationMessage?: string
}

const MultiSelectField = ({
  sx,
  name,
  required,
  selected,
  handleSelected,
  datas,
  inputStyle,
  labelStyle,
  disabled,
  hasText,
  text,
  handleText,
  multiline,
  validationMessage,
}: Props) => {
  const { t } = useTranslation("translation", { keyPrefix: "base" })

  const style = sx || {}

  const customStyle = {
    "& ::before": {
      borderBottomColor: "#d4d3d7 !important",
    },
  }

  const isOther = () => {
    for (let selection of selected) {
      for (const item of datas) {
        if (item.value === selection) {
          if (item.label === "その他") {
            return true
          }
        }
      }
    }

    return false
  }

  return (
    <Box
      sx={{
        width: "355px",
        ...style,
        ...customStyle,
      }}
    >
      {name && (
        <Box display="flex" sx={{ mb: "8px" }}>
          <Typography.InputFieldTitle sx={{ mr: "6px", ...labelStyle }}>
            {name}
          </Typography.InputFieldTitle>
          {required && (
            <Box
              sx={{
                px: "8px",
                borderWidth: "1px",
                borderStyle: "solid",
                borderRadius: "4px",
                borderColor: "text.border",
              }}
            >
              <Typography.InputFieldRequired sx={{ m: "auto", color: "text.border" }}>
                {t("required")}
              </Typography.InputFieldRequired>
            </Box>
          )}
        </Box>
      )}
      <Select
        multiple
        variant="standard"
        sx={{ ...inputStyle, mt: 0, mb: 0 }}
        placeholder={t("please_select")}
        value={selected}
        onChange={(event) => handleSelected(event.target.value)}
        disabled={disabled}
        renderValue={(selected) => (
          <Stack gap={1} direction="row" flexWrap="wrap">
            {selected.map((value) => (
              <Chip
                key={value}
                label={getLabel(datas, value as number)}
                onDelete={() => handleSelected(selected.filter((item) => item !== value))}
                deleteIcon={<CancelIcon onMouseDown={(event) => event.stopPropagation()} />}
              />
            ))}
          </Stack>
        )}
      >
        {datas.map((data, index) => {
          return (
            <MenuItem value={data.value} key={index}>
              {data.label}
            </MenuItem>
          )
        })}
      </Select>
      {hasText && isOther() && (
        <TextField
          variant="standard"
          sx={{
            width: "200px",
            fontFamily: "Noto Sans JP !important",
            mt: "10px",
          }}
          multiline={multiline}
          minRows={multiline ? 4 : 1}
          disabled={disabled}
          value={text}
          onChange={(event) => handleText!(event.target.value)}
        />
      )}
      {validationMessage && (
        <Box sx={{ height: "20px", pt: "5px" }}>
          <Typography.ValidationText>{validationMessage}</Typography.ValidationText>
        </Box>
      )}
    </Box>
  )
}

export default MultiSelectField
